export const reactToMessageMutation = `
      mutation ReactToMessage($messageId: ID!, $emoji: String) {
        reactToMessage(id: $messageId, emoji: $emoji)
      }
    `;
